module.exports = __webpack_public_path__ + "static/media/tickIcon.45adda0b.svg";